"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navbar = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Avatar = require("../Avatar");
var _back_arrow = _interopRequireDefault(require("../../assets/images/back_arrow.svg"));
var _context = require("../ConfigProvider/context");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
var _useTracking2 = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('navbar');
var Navbar = function Navbar(props) {
  var _useContext = (0, _react.useContext)(_context.ConfigContext),
    translations = _useContext.translations;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var className = props.className,
    _props$avatarProps = props.avatarProps,
    avatarProps = _props$avatarProps === void 0 ? {} : _props$avatarProps,
    _props$title = props.title,
    title = _props$title === void 0 ? (translations === null || translations === void 0 ? void 0 : translations.page_head_title) || trans(_constants.PAGE_HEAD_TITLE) : _props$title,
    _props$showBoxShadow = props.showBoxShadow,
    showBoxShadow = _props$showBoxShadow === void 0 ? true : _props$showBoxShadow;
  var _useTracking = (0, _useTracking2.useTracking)(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick;
  var onBackButtonClick = function onBackButtonClick() {
    var _props$trackingData, _props$trackingData$t, _props$onBackButtonCl;
    trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
      data: _objectSpread(_objectSpread({}, trackingClick.data || {}), ((_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : (_props$trackingData$t = _props$trackingData.trackingdataClick) === null || _props$trackingData$t === void 0 ? void 0 : _props$trackingData$t.call(_props$trackingData, props.componentData || {})) || {})
    }));
    (_props$onBackButtonCl = props.onBackButtonClick) === null || _props$onBackButtonCl === void 0 ? void 0 : _props$onBackButtonCl.call(props);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(PREFIX, className, (0, _defineProperty2.default)({}, "".concat(PREFIX, "-shadow"), showBoxShadow))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "__back"),
    onClick: onBackButtonClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _back_arrow.default
  })), /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, avatarProps), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(PREFIX, "__title")
  }, title));
};
exports.Navbar = Navbar;